var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUspArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.28 179.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".usparrows{fill:#83c60e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "usparrows",
    d: "M114.94,179.41s13.19-35.18-23.54-77.08c-36.73-41.9-9.57-72.94,0-80.19,2.85,12.93,9.99,22.18,14.65,25.28-3.2-16.2-5.27-41.71-4.33-47.43-11.09,5.33-26.71,8.92-49.89,15.33,10.28,1.16,27.35-.48,27.35-.48,0,0-24.9,18.3-23.47,49.21,1.42,30.91,25.74,85.75-17.72,115.36H114.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "usparrows",
    d: "M100.56,179.41h60.71s-13.17-30.13-44.09-60.79c-30.91-30.65,17.94-57.81,17.94-57.81,0,0-2.47,11.35-.14,22.12l18.86-50.7-53.29,27.03c-.11,.12,17.13-.29,24.57-5.69,0,0-30.4,16.43-30.19,45.14,.21,28.71,31.2,47.85,5.62,80.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "usparrows",
    d: "M77.62,179.41s-3.29-34.4-19.32-56.39-23.54-41.39-25.87-55.22c5.43,9.44,16.55,10.48,16.55,10.48L31.14,37.67,0,75.17s13.81-2.07,17.94-6.21c-.78,18.11,19.66,48.63,17.07,68.29-2.59,19.66-14.49,42.16-14.49,42.16h57.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspArrows);
export default __webpack_public_path__ + "static/media/UspArrows.6038546a2c6fbc5d13d2772de9544c2e.svg";
export { ForwardRef as ReactComponent };